import { render, staticRenderFns } from "./LiveChatMp4ZipDecision.vue?vue&type=template&id=2c354c74&scoped=true&"
import script from "./LiveChatMp4ZipDecision.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4ZipDecision.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4ZipDecision.vue?vue&type=style&index=0&id=2c354c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c354c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
